import {Location} from '@/components/Home/Sedi';
import Image from "next/image";
import {MapPin, MoveRight, Phone} from "lucide-react";
import Link from "next/link";

interface PointCardProps {
    locations: Location;
}

export const PointCard = ({ locations }: PointCardProps) => {
    const href = locations.slug ? `/dove-siamo/${locations.slug}` : locations.linkMaps;
    const isExternal = !locations.slug && !!locations.linkMaps;

    return (
        <div className="flex min-h-[370px] max-w-[320px] flex-col rounded-lg border border-gray-200 bg-gray-50 p-3 shadow-sm">
            <div className="w-full overflow-hidden rounded-lg">
                <Image
                    src={locations.imgUrl}
                    alt={locations.title}
                    width={500}
                    height={352}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    className="object-cover"
                />
            </div>

            <h3 className="mt-4 text-lg font-semibold text-gray-900">{locations.title}</h3>

            <div className="mt-2 flex items-center gap-2 text-sm text-gray-700">
                <MapPin className="w-5 h-5 text-[#000D7D]" />
                <span className="leading-tight">{locations.address}</span>
            </div>

            <div className="mt-1 flex items-center gap-2 text-sm text-gray-700">
                <Phone className="w-5 h-5 text-[#000D7D]" />
                <span className="leading-tight">{locations.phone}</span>
            </div>

            <div className="flex justify-end mt-auto">
                <Link
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-[#000D7D] text-white transition-transform hover:scale-105"
                    href={href}
                    aria-label={`Vai alla pagina di ${locations.title}`}
                    hrefLang={"it"}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                >
                    <MoveRight className="w-5 h-5" />
                </Link>
            </div>
        </div>
    )
}

export default PointCard;
